import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',
    fontSize: 20,
    lineHeight: '20px',
    '&:before': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '1%',
      right: '1%',
      borderTop: '1px solid #333333',
      transform: 'translateY(-50%)',
      zIndex: 1,
    }
  },
  pastStep: {
    color: '#BD965F',
    zIndex: 2,
  },
  remainingStep: {
    color: '#333333',
    zIndex: 2,
  },
  currentStep: {
    color: 'white',
    textStrokeWidth: 1,
    textStrokeColor: '#BD965F',
    zIndex: 2,
  },
});

export const ProgressBar = ({
  currentStep,
  totalSteps
}) => {
  const classes = useStyles();

  if (totalSteps < 2) return null;

  const remainingSteps = totalSteps - currentStep - 1;

  return (
    <div className={classes.root}>
      {Array.from({ length: currentStep }, (v, i) => (
        <div className={classes.pastStep} key={i}>&#9679;</div>
      ))}

      <div className={classes.currentStep}>&#9670;</div>

      {Array.from({ length: remainingSteps }, (v, i) => (
        <div className={classes.remainingStep} key={i}>&#9679;</div>
      ))}
    </div>
  );
};

ProgressBar.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
};

export default ProgressBar;
